import { lazy } from 'react';

export const EditOfferingPageLazy = lazy(() => import('./edit-offering'));
